import type { AppLang } from '../detectLang';
import { zhAdmin } from './admin.zh';

export type AdminMessages = {
  userManagement: {
    title: string;
    createAccount: string;
    colUsername: string;
    colEmail: string;
    colRole: string;
    colCreatedAt: string;
    colStatus: string;
    colActions: string;
    blockUser: string;
    activateUser: string;
    dialogTitle: string;
    email: string;
    password: string;
    confirmPassword: string;
    submitCreate: string;
  };
  staffManagement: {
    title: string;
    addStaff: string;
    colUsername: string;
    colEmail: string;
    colRole: string;
    colStatus: string;
    colCreatedAt: string;
    colActions: string;
    edit: string;
    promote: string;
    block: string;
    activate: string;
    editDialogTitle: string;
    createDialogTitle: string;
    username: string;
    email: string;
    password: string;
    saveChanges: string;
    create: string;
  };
  userStaffManagement: {
    title: string;
    subtitle: string;
    add: string;
    empty: string;
    emptyHint: string;
    listTitle: string;
    statTotal: string;
    statActive: string;
    statBlocked: string;
    statTotalShort: string;
    statActiveShort: string;
    statBlockedShort: string;
    colUsername: string;
    colEmail: string;
    colStatus: string;
    colCreatedAt: string;
    colActions: string;
    edit: string;
    block: string;
    activate: string;
    createTitle: string;
    editTitle: string;
    email: string;
    password: string;
    username: string;
    usernameOptional: string;
    usernameHint: string;
    newPassword: string;
    newPasswordHint: string;
    cancel: string;
    create: string;
    save: string;
    emailPasswordRequired: string;
    loadFail: string;
    createOk: string;
    createFail: string;
    updateOk: string;
    updateFail: string;
    toggleFail: string;
  };
  customFrames: {
    title: string;
    addNew: string;
    filterBySize: string;
    empty: string;
    emptyFiltered: string;
    photosCount: string;
    active: string;
    inactive: string;
    createdBy: string;
    created: string;
    editFrame: string;
    deleteFrame: string;
    endOfList: string;
    createDialog: string;
    editDialog: string;
    frameName: string;
    size: string;
    designLink: string;
    designLinkPlaceholder: string;
    designLinkHelper: string;
    createFrame: string;
    updateFrame: string;
    deleteDialogTitle: string;
    deleteConfirm: string;
  };
  albums: {
    title: string;
    subtitle: string;
    createNew: string;
    creating: string;
    empty: string;
    pathSuffix: string;
    albumLink: string;
    coverImage: string;
    noCover: string;
    enabled: string;
    disabled: string;
    editDialog: string;
    createDialog: string;
    pageName: string;
    isActive: string;
    pageList: string;
    pageOrder: string;
    coverPage: string;
    coverPageHint: string;
    framePage: string;
    demoPreview: string;
    pageSettings: string;
    coverPhoto: string;
    backgroundPhoto: string;
    selectCover: string;
    selectBackground: string;
    removeCover: string;
    uploading: string;
    pickPageHint: string;
    saveChanges: string;
    create: string;
  };
  landing: {
    title: string;
    subtitle: string;
    classicForm: string;
    canvasMode: string;
    publicLabel: string;
    copy: string;
    open: string;
    settingsTitle: string;
    reload: string;
    loading: string;
    saveConfig: string;
    saving: string;
    unsavedTitle: string;
    unsavedBody: string;
    stay: string;
    leaveWithoutSave: string;
    saveAndLeave: string;
  };
  desktops: {
    title: string;
    refresh: string;
    totalMachines: string;
    colMachineCode: string;
    colRandomCode: string;
    colMachineName: string;
    colUser: string;
    colStatus: string;
    colType: string;
    colCreatedAt: string;
    colUpdatedAt: string;
    colActions: string;
    active: string;
    inactive: string;
    connected: string;
    disconnected: string;
    unknownType: string;
    updateRandomCode: string;
    previous: string;
    next: string;
    pageOf: string;
    dialogTitle: string;
    dialogConfirm: string;
    currentRandomCode: string;
    update: string;
  };
  softwareUpdate: {
    title: string;
    refresh: string;
    dropActive: string;
    dropIdleApk: string;
    dropIdleExe: string;
    currentChannel: string;
    hintApk: string;
    hintExe: string;
    uploading: string;
    currentFile: string;
    fileName: string;
    fileSize: string;
    uploadDate: string;
    uploadedBy: string;
    download: string;
    empty: string;
    updateInfo: string;
    saveInfo: string;
    saving: string;
    deleteTitle: string;
    deleteConfirm: string;
    deleting: string;
  };
  email: {
    tabCompose: string;
    tabSent: string;
    title: string;
    subject: string;
    subjectPlaceholder: string;
    bodyLabel: string;
    bodyPlaceholder: string;
    recipientList: string;
    recipientPlaceholder: string;
    clearAll: string;
    clearAllConfirm: string;
    sendingProgress: string;
    cancelSendConfirm: string;
    send: string;
    sending: string;
    search: string;
    searchPlaceholder: string;
    deleteSelected: string;
    deleteConfirm: string;
    colSubject: string;
    colPreview: string;
    colRecipients: string;
    colStats: string;
    colTime: string;
    empty: string;
    statsChip: string;
    recipientsCount: string;
    pageOf: string;
    prev: string;
    next: string;
    detailTitle: string;
    noData: string;
  };
  userDetail: {
    userNotFound: string;
    tabs: {
      profile: string;
      pro: string;
      proFull: string;
      lite: string;
      liteFull: string;
      mono: string;
      monoFull: string;
      frame: string;
      frameFull: string;
      media: string;
      device: string;
      deviceFull: string;
      sepay: string;
      staff: string;
    };
    deviceAccess: string;
    deviceAccessHint: string;
    uploadMethod: string;
    uploadMethodHint: string;
    uploadMethodServer: string;
    uploadMethodServerDesc: string;
    uploadMethodSigned: string;
    uploadMethodSignedDesc: string;
    toastUploadMethodUpdated: string;
    toastUploadMethodFail: string;
    accountTitle: string;
    accountHint: string;
    roleUser: string;
    roleAdmin: string;
    roleStaff: string;
    statusActive: string;
    statusInactive: string;
    changePassword: string;
    changePasswordHint: string;
    newPassword: string;
    confirmAsAdmin: string;
    adminPassword: string;
    confirm: string;
    deviceSettings: string;
    toggleDevice: string;
    toggleDeviceFull: string;
    toggleDeviceDesc: string;
    toggleEdit: string;
    toggleEditFull: string;
    toggleEditDesc: string;
    toggleMerge: string;
    toggleMergeFull: string;
    toggleMergeDesc: string;
    toggleBgRemoval: string;
    toggleBgRemovalFull: string;
    toggleBgRemovalDesc: string;
    machinesTitle: string;
    machinesCount: string;
    deviceOffWarning: string;
    noMachines: string;
    tabPrev: string;
    tabNext: string;
    on: string;
    off: string;
    toastLoadUserFail: string;
    toastDeviceUpdated: string;
    toastDeviceUpdateFail: string;
    toastEditOn: string;
    toastEditOff: string;
    toastEditFail: string;
    toastMergeOn: string;
    toastMergeOff: string;
    toastMergeFail: string;
    toastBgRemovalOn: string;
    toastBgRemovalOff: string;
    toastBgRemovalFail: string;
    toastAccessUpdated: string;
    toastAccessFail: string;
    toastStatusUpdated: string;
    toastStatusFail: string;
    toastUsernameEmailRequired: string;
    toastInfoUpdated: string;
    toastInfoFail: string;
    toastNeedNewPassword: string;
    toastNeedAdminPassword: string;
    toastPasswordUpdated: string;
    toastPasswordFail: string;
    toastMachinesFail: string;
    toastMachineDetailFail: string;
    toastCopiedCode: string;
    toastCopiedLink: string;
    toastCopyFail: string;
    toastAvatarType: string;
    toastAvatarOk: string;
    toastAvatarFail: string;
  };
  backgroundAi: {
    title: string;
    subtitle: string;
    providerTitle: string;
    using: string;
    balance: string;
    quality: string;
    qualityLow: string;
    qualityMedium: string;
    qualityHigh: string;
    chooseModel: string;
    openList: string;
    noModels: string;
    falKey: string;
    piapiKey: string;
    noKey: string;
    revealCountdown: string;
    keyHint: string;
    saveProvider: string;
    falBalance: string;
    falBalanceLoading: string;
    saving: string;
    missingKey: string;
    presetsTitle: string;
    loading: string;
    presetCount: string;
    reload: string;
    createNew: string;
    noPresets: string;
    accountsTitle: string;
    statsTitle: string;
    enabledCount: string;
    searchUsers: string;
    noUsers: string;
    usageHistory: string;
    themeList: string;
    themeDialog: string;
    noUserThemes: string;
    addTheme: string;
    editTheme: string;
    themeName: string;
    themeDescription: string;
    themeImage: string;
    backgrounds: string;
    backgroundCount: string;
    addBackground: string;
    editBackground: string;
    backgroundName: string;
    tags: string;
    tagMale: string;
    tagFemale: string;
    tagGroup: string;
    tagsRequired: string;
    confirmDeleteTheme: string;
    confirmDeleteBackground: string;
    emptyBackgrounds: string;
    back: string;
    accountGenHint: string;
    accountGenSaved: string;
    accountGenFail: string;
    multiSlotTitle: string;
    multiSlotHint: string;
    multiSlotConfirm: string;
    multiSlotConfirmTitle: string;
    multiSlotConfirmYes: string;
    multiSlotImages: string;
    quotaTitle: string;
    quotaHint: string;
    quotaPlaceholder: string;
    quotaUsed: string;
    quotaRemaining: string;
    quotaUnlimited: string;
    usageTitle: string;
    usageEmpty: string;
    usageMachine: string;
    usageMachineNamed: string;
    usageUnnamed: string;
    usageShowing: string;
    usageCostTotal: string;
    usageCostCalculating: string;
    usageChart2m: string;
    usageChart1m: string;
    usageChart2w: string;
    usageChart1w: string;
    usageChart7d: string;
    usageChart1d: string;
    usageChart2d: string;
    usageChartFrom: string;
    usageChartTo: string;
    usageChartAccounts: string;
    usageChartAllAccounts: string;
    usageLoadMore: string;
    usageTheme: string;
    usageBackground: string;
    usageSearch: string;
    usageSubjectStats: string;
    usageSubjectEmpty: string;
    usageSubjectUnknown: string;
    usageSubjectDayHint: string;
    usageSubjectWholeRange: string;
    usageSubjectTabUse: string;
    usageSubjectMoney: string;
    usageSubjectMoneyEmpty: string;
    usageCostRateLimit: string;
    usageFilterAll: string;
    usageNoMatch: string;
    usageLoadFail: string;
    editPreset: string;
    createPreset: string;
    presetName: string;
    prompt: string;
    promptHelper: string;
    chooseImage: string;
    cancel: string;
    save: string;
    create: string;
    revealTitle: string;
    revealBody: string;
    adminPassword: string;
    view: string;
    toastLoadPresetsFail: string;
    toastLoadUsersFail: string;
    toastNamePromptRequired: string;
    toastPresetSaved: string;
    toastPresetCreated: string;
    toastPresetSaveFail: string;
    toastPresetDeleted: string;
    toastPresetDeleteFail: string;
    toastDeleteConfirm: string;
    toastUserToggleFail: string;
    toastPasswordRequired: string;
    toastPasswordWrong: string;
    toastQualityFail: string;
    toastModelSelected: string;
    toastModelFail: string;
    toastProviderSwitched: string;
    toastProviderFail: string;
    toastCatalogFail: string;
  };
};

const en: AdminMessages = {
  userManagement: {
    title: 'User Management',
    createAccount: 'Create',
    colUsername: 'Username',
    colEmail: 'Email',
    colRole: 'Role',
    colCreatedAt: 'Created At',
    colStatus: 'Status',
    colActions: 'Actions',
    blockUser: 'Block User',
    activateUser: 'Activate User',
    dialogTitle: 'Create new account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    submitCreate: 'Create account',
  },
  staffManagement: {
    title: 'Staff Management',
    addStaff: 'Add Staff',
    colUsername: 'Username',
    colEmail: 'Email',
    colRole: 'Role',
    colStatus: 'Status',
    colCreatedAt: 'Created At',
    colActions: 'Actions',
    edit: 'Edit',
    promote: 'Promote to Admin',
    block: 'Block Account',
    activate: 'Activate Account',
    editDialogTitle: 'Edit Staff Member',
    createDialogTitle: 'Create New Staff Account',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    saveChanges: 'Save Changes',
    create: 'Create',
  },
  userStaffManagement: {
    title: 'Staff accounts',
    subtitle: 'Create and manage staff logins for this account. Staff can view photos and devices only.',
    add: 'Add staff',
    empty: 'No staff accounts yet',
    emptyHint: 'Create a staff account so teammates can view photos and devices.',
    listTitle: 'Staff list',
    statTotal: 'Total staff',
    statActive: 'Active',
    statBlocked: 'Blocked',
    statTotalShort: 'Total',
    statActiveShort: 'Active',
    statBlockedShort: 'Blocked',
    colUsername: 'Username',
    colEmail: 'Email',
    colStatus: 'Status',
    colCreatedAt: 'Created',
    colActions: 'Actions',
    edit: 'Edit',
    block: 'Block',
    activate: 'Activate',
    createTitle: 'Create staff account',
    editTitle: 'Edit staff account',
    email: 'Email',
    password: 'Password',
    username: 'Username',
    usernameOptional: 'Username (optional)',
    usernameHint: 'Leave empty to generate from email',
    newPassword: 'New password',
    newPasswordHint: 'Leave empty to keep the current password',
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
    emailPasswordRequired: 'Email and password are required',
    loadFail: 'Failed to load staff',
    createOk: 'Staff account created',
    createFail: 'Failed to create staff',
    updateOk: 'Staff account updated',
    updateFail: 'Failed to update staff',
    toggleFail: 'Failed to update status',
  },
  customFrames: {
    title: 'Custom Frame Management',
    addNew: 'Add New Frame',
    filterBySize: 'Filter by frame size',
    empty: 'No custom frames yet',
    emptyFiltered: 'No frames match the current filter',
    photosCount: '{n} photos',
    active: 'Active',
    inactive: 'Inactive',
    createdBy: 'Created by: {name}',
    created: 'Created: {date}',
    editFrame: 'Edit Frame',
    deleteFrame: 'Delete Frame',
    endOfList: 'Showing all {n} custom frames (total {total})',
    createDialog: 'Create New Custom Frame',
    editDialog: 'Edit Custom Frame',
    frameName: 'Frame Name',
    size: 'Size',
    designLink: 'Design link',
    designLinkPlaceholder: 'Enter design link',
    designLinkHelper: 'Link to the design file or page',
    createFrame: 'Create Frame',
    updateFrame: 'Update Frame',
    deleteDialogTitle: 'Delete Custom Frame',
    deleteConfirm: 'Are you sure you want to delete this custom frame?',
  },
  albums: {
    title: 'Album page management',
    subtitle: 'Create different album links and customize cover + background images.',
    createNew: 'Create new album page',
    creating: 'Creating…',
    empty: 'No album pages yet.',
    pathSuffix: 'Path suffix',
    albumLink: 'Album link',
    coverImage: 'Cover image',
    noCover: 'No cover image yet',
    enabled: 'Enabled',
    disabled: 'Disabled',
    editDialog: 'Edit album page',
    createDialog: 'Create album page',
    pageName: 'Album page name',
    isActive: 'Active',
    pageList: 'Page list',
    pageOrder: 'Order',
    coverPage: 'Page 01 - Album cover',
    coverPageHint: 'Edit name/slug, cover and background images',
    framePage: 'Page {n} - {name}',
    demoPreview: 'Album UI demo',
    pageSettings: 'Page settings',
    coverPhoto: 'Cover photo',
    backgroundPhoto: 'Background photo',
    selectCover: 'Select cover',
    selectBackground: 'Select background',
    removeCover: 'Remove cover',
    uploading: 'Uploading...',
    pickPageHint: 'Select a page to edit settings.',
    saveChanges: 'Save changes',
    create: 'Create',
  },
  landing: {
    title: 'Landing page (HTML backend)',
    subtitle: 'Choose Classic form or Drag-and-drop canvas. Remember to Save when done.',
    classicForm: 'Classic form',
    canvasMode: 'Drag-and-drop canvas',
    publicLabel: 'Public:',
    copy: 'Copy',
    open: 'Open',
    settingsTitle: 'Content settings',
    reload: 'Reload',
    loading: 'Loading…',
    saveConfig: 'Save configuration',
    saving: 'Saving…',
    unsavedTitle: 'Unsaved changes',
    unsavedBody: 'Do you want to save before leaving?',
    stay: 'Stay',
    leaveWithoutSave: 'Leave without saving',
    saveAndLeave: 'Save and leave',
  },
  desktops: {
    title: 'Desktop Management',
    refresh: 'Refresh',
    totalMachines: 'Total: {n} machines',
    colMachineCode: 'Machine Code',
    colRandomCode: 'Random Code',
    colMachineName: 'Machine Name',
    colUser: 'User',
    colStatus: 'Status',
    colType: 'Type',
    colCreatedAt: 'Created At',
    colUpdatedAt: 'Updated At',
    colActions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    connected: 'Connected',
    disconnected: 'Disconnected',
    unknownType: 'Unknown',
    updateRandomCode: 'Update Random Code',
    previous: 'Previous',
    next: 'Next',
    pageOf: 'Page {page} of {totalPages}',
    dialogTitle: 'Update Random Code',
    dialogConfirm: 'Generate a new random code for this machine?',
    currentRandomCode: 'Current Random Code',
    update: 'Update',
  },
  softwareUpdate: {
    title: 'Software Update',
    refresh: 'Refresh',
    dropActive: 'Drop the file here',
    dropIdleApk: 'Drag and drop an .apk file here, or click to select',
    dropIdleExe: 'Drag and drop an .exe file here, or click to select',
    currentChannel: 'Current channel: {channel}',
    hintApk: 'Only .apk files allowed, max 1GB',
    hintExe: 'Only .exe files allowed, max 1GB',
    uploading: 'Uploading file...',
    currentFile: 'Current file',
    fileName: 'File name',
    fileSize: 'Size',
    uploadDate: 'Upload date',
    uploadedBy: 'Uploaded by',
    download: 'Download',
    empty: 'No update file uploaded yet',
    updateInfo: 'Update information',
    saveInfo: 'Save information',
    saving: 'Saving...',
    deleteTitle: 'Confirm delete',
    deleteConfirm: 'Are you sure you want to delete this update file?',
    deleting: 'Deleting...',
  },
  email: {
    tabCompose: 'Compose email',
    tabSent: 'Sent emails',
    title: 'Email',
    subject: 'Email subject',
    subjectPlaceholder: 'Enter email subject...',
    bodyLabel: 'Email body (HTML)',
    bodyPlaceholder: 'Enter email body...',
    recipientList: 'Email list',
    recipientPlaceholder: 'Enter email and press Space…',
    clearAll: 'Clear all',
    clearAllConfirm: 'Clear all emails?',
    sendingProgress: 'Sending: {sent}/{total} emails',
    cancelSendConfirm: 'Are you sure you want to cancel?',
    send: 'Send email',
    sending: 'Sending...',
    search: 'Search',
    searchPlaceholder: 'Search by recipients/subject/sender...',
    deleteSelected: 'Delete',
    deleteConfirm: 'Delete {n} sent emails?',
    colSubject: 'Subject',
    colPreview: 'Preview',
    colRecipients: 'Recipients',
    colStats: 'Stats',
    colTime: 'Time',
    empty: 'No emails yet',
    statsChip: '{sent} SENT / {failed} FAILED',
    recipientsCount: '{n} recipients',
    pageOf: 'Page {page} / {totalPages}',
    prev: 'Prev',
    next: 'Next',
    detailTitle: 'Email Detail',
    noData: 'No data',
  },
  userDetail: {
    userNotFound: 'User not found',
    tabs: {
      profile: 'Profile',
      pro: 'Pro',
      proFull: 'M-Photo Pro',
      lite: 'Lite',
      liteFull: 'M-Photo Lite',
      mono: 'Mono',
      monoFull: 'M-Photo Mono',
      frame: 'Frame',
      frameFull: 'Custom Frame',
      media: 'Media',
      device: 'Device',
      deviceFull: 'Device Management',
      sepay: 'SePay',
      staff: 'Staff',
    },
    deviceAccess: 'Device Access',
    deviceAccessHint: 'Turn products on or off for this account.',
    uploadMethod: 'Gallery upload method',
    uploadMethodHint: 'How booth machines under this account upload photos/videos.',
    uploadMethodServer: 'Traditional (via server)',
    uploadMethodServerDesc: 'App sends files to API; server uploads to Firebase.',
    uploadMethodSigned: 'Direct (signed URL)',
    uploadMethodSignedDesc: 'Server issues a temporary link; app uploads straight to Firebase.',
    toastUploadMethodUpdated: 'Upload method updated',
    toastUploadMethodFail: 'Could not update upload method',
    accountTitle: 'Account Information',
    accountHint: 'Update this user’s account details',
    roleUser: 'User',
    roleAdmin: 'Admin',
    roleStaff: 'Staff',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    changePassword: 'Change Password',
    changePasswordHint: 'Admin can set a new password for this user',
    newPassword: 'New Password',
    confirmAsAdmin: 'Confirm as Admin',
    adminPassword: 'Admin Password',
    confirm: 'Confirm',
    deviceSettings: 'Device settings',
    toggleDevice: 'Device',
    toggleDeviceFull: 'Enable Device Management',
    toggleDeviceDesc: 'Enable QR / device management',
    toggleEdit: 'Edit',
    toggleEditFull: 'Edit page',
    toggleEditDesc: 'Edit button on M-Photo Pro',
    toggleMerge: 'Merge',
    toggleMergeFull: 'Multi capture',
    toggleMergeDesc: 'Combined capture / combined print',
    toggleBgRemoval: 'BG',
    toggleBgRemovalFull: 'Background removal',
    toggleBgRemovalDesc: 'AI background removal on M-Photo Pro + custom frame backgrounds',
    machinesTitle: 'User machines',
    machinesCount: '{n} machines',
    deviceOffWarning: 'Device is off — registered machines can still be viewed.',
    noMachines: 'No machines yet.',
    tabPrev: 'Previous tab',
    tabNext: 'Next tab',
    on: 'ON',
    off: 'OFF',
    toastLoadUserFail: 'Failed to load user information',
    toastDeviceUpdated: 'Device management status updated',
    toastDeviceUpdateFail: 'Failed to update device management status',
    toastEditOn: 'Edit page enabled',
    toastEditOff: 'Edit page disabled',
    toastEditFail: 'Failed to update edit page status',
    toastMergeOn: 'Multi capture enabled',
    toastMergeOff: 'Multi capture disabled',
    toastMergeFail: 'Failed to update multi capture status',
    toastBgRemovalOn: 'Background removal enabled',
    toastBgRemovalOff: 'Background removal disabled',
    toastBgRemovalFail: 'Failed to update background removal status',
    toastAccessUpdated: 'Device access updated',
    toastAccessFail: 'Failed to update device access',
    toastStatusUpdated: 'User status updated',
    toastStatusFail: 'Failed to update user status',
    toastUsernameEmailRequired: 'Username and email are required',
    toastInfoUpdated: 'User information updated',
    toastInfoFail: 'Failed to update user information',
    toastNeedNewPassword: 'Please enter a new password',
    toastNeedAdminPassword: 'Please enter your admin password',
    toastPasswordUpdated: 'User password updated',
    toastPasswordFail: 'Failed to update user password',
    toastMachinesFail: 'Failed to load user machines',
    toastMachineDetailFail: 'Failed to load machine detail',
    toastCopiedCode: 'Copied random code',
    toastCopiedLink: 'Copied upload link',
    toastCopyFail: 'Cannot copy text',
    toastAvatarType: 'Please choose an image file',
    toastAvatarOk: 'Avatar updated',
    toastAvatarFail: 'Could not update avatar',
  },
  backgroundAi: {
    title: 'Background AI',
    subtitle: 'Shared Fal and PiAPI keys. Each account chooses its own provider, quality, and model.',
    providerTitle: 'Provider',
    using: 'Using {name}',
    balance: ' · balance {n}{usd} credit',
    quality: 'Quality',
    qualityLow: 'Low',
    qualityMedium: 'Medium',
    qualityHigh: 'High',
    chooseModel: 'Choose a model',
    openList: 'Tap to open the list',
    noModels: 'No image models.',
    falKey: 'Fal key',
    piapiKey: 'PiAPI key',
    noKey: 'No {name} key yet',
    revealCountdown: 'Confirmed · {s}s left before asking for the password again',
    keyHint: 'Paste a new key to replace it. The eye button shows the key (admin password required).',
    saveProvider: 'Save keys',
    falBalance: 'Fal balance: {amount}',
    falBalanceLoading: 'Checking Fal balance...',
    saving: 'Saving...',
    missingKey: 'The selected provider has no API key. Paste one above or set PIAPI_API_KEY / FAL_KEY in .env.',
    presetsTitle: 'Backgrounds',
    loading: 'Loading...',
    presetCount: '{n} items',
    reload: 'Reload',
    createNew: 'New background',
    noPresets: 'No backgrounds yet. Create one with a prompt and a preview image.',
    accountsTitle: 'Account management',
    statsTitle: 'Statistics',
    enabledCount: '{n} enabled',
    searchUsers: 'Search username or email',
    noUsers: 'No matching users.',
    usageHistory: 'Generation history',
    themeList: 'AI theme list',
    themeDialog: 'AI themes',
    noUserThemes: 'This account has no AI themes yet.',
    addTheme: 'Add AI theme',
    editTheme: 'Edit AI theme',
    themeName: 'Theme name',
    themeDescription: 'Description',
    themeImage: 'Theme image',
    backgrounds: 'AI backgrounds',
    backgroundCount: '{n} AI background',
    addBackground: 'Add AI background',
    editBackground: 'Edit AI background',
    backgroundName: 'Background name',
    tags: 'Tags',
    tagMale: 'Male',
    tagFemale: 'Female',
    tagGroup: 'Group',
    tagsRequired: 'Choose at least one tag.',
    confirmDeleteTheme: 'Delete this AI theme and every background inside it?',
    confirmDeleteBackground: 'Delete this AI background?',
    emptyBackgrounds: 'This theme has no AI backgrounds yet.',
    back: 'Back',
    accountGenHint: 'The API key stays shared. Provider, quality, and model here apply only to this account on mlite and mobile upload.',
    accountGenSaved: 'Saved image settings for this account',
    accountGenFail: 'Could not save image settings',
    multiSlotTitle: 'AI for multi-photo frames',
    multiSlotHint: 'When on, frames with 2 or more photos can create AI images. Each photo is one provider request.',
    multiSlotConfirm: 'AI cost will be higher because each photo in the frame is generated separately. Turn this on?',
    multiSlotConfirmTitle: 'Turn on multi-photo AI?',
    multiSlotConfirmYes: 'Turn on',
    multiSlotImages: '{n} photos',
    quotaTitle: 'Remaining AI turns',
    quotaHint: 'The number you save becomes the remaining turns. Each generated photo uses one turn. Leave empty for no limit.',
    quotaPlaceholder: 'No limit',
    quotaUsed: 'Used: {n}',
    quotaRemaining: 'Remaining: {n}',
    quotaUnlimited: 'No limit',
    usageTitle: 'AI generations · {name}',
    usageEmpty: 'No AI generations for this account yet.',
    usageMachine: 'Machine {code}',
    usageMachineNamed: '{name} ({code})',
    usageUnnamed: '{kind} machine',
    usageShowing: '{n} generations',
    usageCostTotal: 'Total ${amount}',
    usageCostCalculating: 'Calculating',
    usageChart2m: '2 months',
    usageChart1m: '1 month',
    usageChart2w: '2 weeks',
    usageChart1w: '1 week',
    usageChart7d: '7 days',
    usageChart1d: '1 day',
    usageChart2d: '2 days',
    usageChartFrom: 'From',
    usageChartTo: 'To',
    usageChartAccounts: 'Accounts',
    usageChartAllAccounts: 'All accounts',
    usageLoadMore: 'Load more',
    usageTheme: 'Theme',
    usageBackground: 'Background',
    usageSearch: 'Search machine name',
    usageSubjectStats: 'Usage stats',
    usageSubjectEmpty: 'No generations in this range',
    usageSubjectUnknown: 'Unknown',
    usageSubjectDayHint: 'Tap a day to see that day',
    usageSubjectWholeRange: 'Whole range',
    usageSubjectTabUse: 'Usage',
    usageSubjectMoney: 'Spending',
    usageSubjectMoneyEmpty: 'No spending in this range',
    usageCostRateLimit: 'Fal is limiting price lookups. Wait a moment, then open statistics again.',
    usageFilterAll: 'All',
    usageNoMatch: 'No machines match.',
    usageLoadFail: 'Could not load AI generations',
    editPreset: 'Edit AI background',
    createPreset: 'Create AI background',
    presetName: 'Name',
    prompt: 'Background prompt',
    promptHelper: 'Describe the background only. The person in the photo stays the same.',
    chooseImage: 'Choose a preview image',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    revealTitle: 'Confirm — view API key',
    revealBody: 'Enter the password of the admin account you are signed in with. After it is correct, it will not ask again for 5 minutes.',
    adminPassword: 'Admin password',
    view: 'View',
    toastLoadPresetsFail: 'Could not load AI backgrounds',
    toastLoadUsersFail: 'Could not load users',
    toastNamePromptRequired: 'Enter a name and a background prompt',
    toastPresetSaved: 'AI background saved',
    toastPresetCreated: 'AI background created',
    toastPresetSaveFail: 'Could not save the AI background',
    toastPresetDeleted: 'AI background deleted',
    toastPresetDeleteFail: 'Could not delete the AI background',
    toastDeleteConfirm: 'Delete "{name}"?',
    toastUserToggleFail: 'Could not update user access',
    toastPasswordRequired: 'Enter the admin account password.',
    toastPasswordWrong: 'Incorrect password.',
    toastQualityFail: 'Could not save quality',
    toastModelSelected: 'Selected {model}',
    toastModelFail: 'Could not save the model',
    toastProviderSwitched: 'API keys saved',
    toastProviderFail: 'Could not save the AI provider',
    toastCatalogFail: 'Could not load the model list',
  },
};

const vi: AdminMessages = {
  userManagement: {
    title: 'Quản lý người dùng',
    createAccount: 'Tạo',
    colUsername: 'Tên người dùng',
    colEmail: 'Email',
    colRole: 'Vai trò',
    colCreatedAt: 'Ngày tạo',
    colStatus: 'Trạng thái',
    colActions: 'Thao tác',
    blockUser: 'Chặn người dùng',
    activateUser: 'Kích hoạt',
    dialogTitle: 'Tạo tài khoản mới',
    email: 'Email',
    password: 'Mật khẩu',
    confirmPassword: 'Xác nhận mật khẩu',
    submitCreate: 'Tạo tài khoản',
  },
  staffManagement: {
    title: 'Quản lý nhân viên',
    addStaff: 'Thêm nhân viên',
    colUsername: 'Tên người dùng',
    colEmail: 'Email',
    colRole: 'Vai trò',
    colStatus: 'Trạng thái',
    colCreatedAt: 'Ngày tạo',
    colActions: 'Thao tác',
    edit: 'Sửa',
    promote: 'Thăng cấp Admin',
    block: 'Chặn tài khoản',
    activate: 'Kích hoạt tài khoản',
    editDialogTitle: 'Sửa nhân viên',
    createDialogTitle: 'Tạo tài khoản nhân viên',
    username: 'Tên người dùng',
    email: 'Email',
    password: 'Mật khẩu',
    saveChanges: 'Lưu thay đổi',
    create: 'Tạo',
  },
  userStaffManagement: {
    title: 'Tài khoản nhân viên',
    subtitle: 'Tạo và quản lý tài khoản nhân viên của tài khoản này. Nhân viên chỉ được xem ảnh và thiết bị.',
    add: 'Thêm nhân viên',
    empty: 'Chưa có nhân viên',
    emptyHint: 'Tạo tài khoản để nhân viên có thể xem ảnh và thiết bị.',
    listTitle: 'Danh sách nhân viên',
    statTotal: 'Tổng nhân viên',
    statActive: 'Đang hoạt động',
    statBlocked: 'Đã khóa',
    statTotalShort: 'Tổng',
    statActiveShort: 'Hoạt động',
    statBlockedShort: 'Đã khóa',
    colUsername: 'Tên đăng nhập',
    colEmail: 'Email',
    colStatus: 'Trạng thái',
    colCreatedAt: 'Ngày tạo',
    colActions: 'Thao tác',
    edit: 'Sửa',
    block: 'Khóa',
    activate: 'Mở khóa',
    createTitle: 'Tạo tài khoản nhân viên',
    editTitle: 'Sửa tài khoản nhân viên',
    email: 'Email',
    password: 'Mật khẩu',
    username: 'Tên đăng nhập',
    usernameOptional: 'Tên đăng nhập (không bắt buộc)',
    usernameHint: 'Để trống sẽ tạo từ email',
    newPassword: 'Mật khẩu mới',
    newPasswordHint: 'Để trống nếu giữ mật khẩu hiện tại',
    cancel: 'Hủy',
    create: 'Tạo',
    save: 'Lưu',
    emailPasswordRequired: 'Cần nhập email và mật khẩu',
    loadFail: 'Không tải được danh sách nhân viên',
    createOk: 'Đã tạo tài khoản nhân viên',
    createFail: 'Không tạo được nhân viên',
    updateOk: 'Đã cập nhật nhân viên',
    updateFail: 'Không cập nhật được nhân viên',
    toggleFail: 'Không đổi được trạng thái',
  },
  customFrames: {
    title: 'Quản lý Custom Frame',
    addNew: 'Thêm frame mới',
    filterBySize: 'Lọc theo kích thước khung',
    empty: 'Không có custom frames nào',
    emptyFiltered: 'Không có frame trong bộ lọc hiện tại',
    photosCount: '{n} ảnh',
    active: 'Đang bật',
    inactive: 'Đang tắt',
    createdBy: 'Tạo bởi: {name}',
    created: 'Tạo lúc: {date}',
    editFrame: 'Sửa Frame',
    deleteFrame: 'Xóa Frame',
    endOfList: 'Đã hiển thị tất cả {n} custom frames (tổng {total} frames)',
    createDialog: 'Tạo Custom Frame mới',
    editDialog: 'Sửa Custom Frame',
    frameName: 'Tên Frame',
    size: 'Kích thước',
    designLink: 'Đường dẫn thiết kế',
    designLinkPlaceholder: 'Nhập đường dẫn thiết kế',
    designLinkHelper: 'Đường dẫn đến thiết kế',
    createFrame: 'Tạo Frame',
    updateFrame: 'Cập nhật Frame',
    deleteDialogTitle: 'Xóa Custom Frame',
    deleteConfirm: 'Bạn có chắc muốn xóa custom frame này?',
  },
  albums: {
    title: 'Quản lý trang Album',
    subtitle: 'Tạo nhiều link album khác nhau và tùy biến ảnh bìa + ảnh nền.',
    createNew: 'Tạo trang album mới',
    creating: 'Đang tạo…',
    empty: 'Chưa có trang album nào.',
    pathSuffix: 'Đuôi đường dẫn',
    albumLink: 'Link album',
    coverImage: 'Ảnh bìa',
    noCover: 'Chưa có ảnh bìa',
    enabled: 'Đang bật',
    disabled: 'Đang tắt',
    editDialog: 'Sửa trang album',
    createDialog: 'Tạo trang album mới',
    pageName: 'Tên trang album',
    isActive: 'Bật hoạt động',
    pageList: 'Danh sách trang',
    pageOrder: 'STT',
    coverPage: 'Trang 01 - Bìa album',
    coverPageHint: 'Chỉnh tên/slug, ảnh bìa và ảnh nền',
    framePage: 'Trang {n} - {name}',
    demoPreview: 'Demo giao diện album',
    pageSettings: 'Cài đặt trang',
    coverPhoto: 'Ảnh bìa',
    backgroundPhoto: 'Ảnh nền',
    selectCover: 'Chọn ảnh bìa',
    selectBackground: 'Chọn ảnh nền',
    removeCover: 'Xóa ảnh bìa',
    uploading: 'Đang upload...',
    pickPageHint: 'Chọn một trang để chỉnh cài đặt.',
    saveChanges: 'Lưu thay đổi',
    create: 'Tạo mới',
  },
  landing: {
    title: 'Landing page (HTML backend)',
    subtitle: 'Chọn Form cổ điển hoặc Canvas kéo thả. Nhớ bấm Lưu khi xong.',
    classicForm: 'Form cổ điển',
    canvasMode: 'Canvas kéo thả',
    publicLabel: 'Công khai:',
    copy: 'Copy',
    open: 'Mở',
    settingsTitle: 'Cài đặt nội dung',
    reload: 'Tải lại',
    loading: 'Đang tải…',
    saveConfig: 'Lưu cấu hình',
    saving: 'Đang lưu…',
    unsavedTitle: 'Chưa lưu cấu hình',
    unsavedBody: 'Bạn có muốn lưu trước khi thoát?',
    stay: 'Ở lại',
    leaveWithoutSave: 'Thoát không lưu',
    saveAndLeave: 'Lưu và thoát',
  },
  desktops: {
    title: 'Quản lý Desktop',
    refresh: 'Làm mới',
    totalMachines: 'Tổng: {n} máy',
    colMachineCode: 'Mã máy',
    colRandomCode: 'Mã ngẫu nhiên',
    colMachineName: 'Tên máy',
    colUser: 'Người dùng',
    colStatus: 'Trạng thái',
    colType: 'Loại máy',
    colCreatedAt: 'Ngày tạo',
    colUpdatedAt: 'Cập nhật',
    colActions: 'Thao tác',
    active: 'Hoạt động',
    inactive: 'Không hoạt động',
    connected: 'Đang kết nối',
    disconnected: 'Mất kết nối',
    unknownType: 'Chưa rõ',
    updateRandomCode: 'Cập nhật mã ngẫu nhiên',
    previous: 'Trước',
    next: 'Sau',
    pageOf: 'Trang {page} / {totalPages}',
    dialogTitle: 'Cập nhật mã ngẫu nhiên',
    dialogConfirm: 'Tạo mã ngẫu nhiên mới cho máy này?',
    currentRandomCode: 'Mã ngẫu nhiên hiện tại',
    update: 'Cập nhật',
  },
  softwareUpdate: {
    title: 'Cập nhật phần mềm',
    refresh: 'Làm mới',
    dropActive: 'Thả file vào đây',
    dropIdleApk: 'Kéo thả file .apk vào đây, hoặc click để chọn',
    dropIdleExe: 'Kéo thả file .exe vào đây, hoặc click để chọn',
    currentChannel: 'Kênh hiện tại: {channel}',
    hintApk: 'Chỉ cho phép file .apk, tối đa 1GB',
    hintExe: 'Chỉ cho phép file .exe, tối đa 1GB',
    uploading: 'Đang upload file...',
    currentFile: 'File hiện tại',
    fileName: 'Tên file',
    fileSize: 'Kích thước',
    uploadDate: 'Ngày upload',
    uploadedBy: 'Upload bởi',
    download: 'Tải xuống',
    empty: 'Chưa có file update nào được upload',
    updateInfo: 'Thông tin cập nhật',
    saveInfo: 'Lưu thông tin',
    saving: 'Đang lưu...',
    deleteTitle: 'Xác nhận xóa',
    deleteConfirm: 'Bạn có chắc muốn xóa file update này?',
    deleting: 'Đang xóa...',
  },
  email: {
    tabCompose: 'Soạn email',
    tabSent: 'Email đã gửi',
    title: 'Email',
    subject: 'Tiêu đề email',
    subjectPlaceholder: 'Nhập tiêu đề email...',
    bodyLabel: 'Nội dung email (HTML)',
    bodyPlaceholder: 'Nhập nội dung email...',
    recipientList: 'Danh sách email',
    recipientPlaceholder: 'Nhập email và nhấn Space…',
    clearAll: 'Xóa tất cả',
    clearAllConfirm: 'Xóa tất cả email?',
    sendingProgress: 'Đang gửi: {sent}/{total} email',
    cancelSendConfirm: 'Bạn có chắc muốn hủy?',
    send: 'Gửi email',
    sending: 'Đang gửi...',
    search: 'Tìm kiếm',
    searchPlaceholder: 'Tìm theo recipients/subject/sender...',
    deleteSelected: 'Xóa',
    deleteConfirm: 'Xóa {n} email đã gửi?',
    colSubject: 'Tiêu đề',
    colPreview: 'Xem trước',
    colRecipients: 'Người nhận',
    colStats: 'Thống kê',
    colTime: 'Thời gian',
    empty: 'Chưa có email nào',
    statsChip: '{sent} SENT / {failed} FAILED',
    recipientsCount: '{n} người nhận',
    pageOf: 'Trang {page} / {totalPages}',
    prev: 'Trước',
    next: 'Sau',
    detailTitle: 'Chi tiết email',
    noData: 'Không có dữ liệu',
  },
  userDetail: {
    userNotFound: 'Không tìm thấy user',
    tabs: {
      profile: 'Hồ sơ',
      pro: 'Pro',
      proFull: 'M-Photo Pro',
      lite: 'Lite',
      liteFull: 'M-Photo Lite',
      mono: 'Mono',
      monoFull: 'M-Photo Mono',
      frame: 'Khung',
      frameFull: 'Custom Frame',
      media: 'Media',
      device: 'Thiết bị',
      deviceFull: 'Quản lý thiết bị',
      sepay: 'SePay',
      staff: 'Nhân viên',
    },
    deviceAccess: 'Quyền thiết bị',
    deviceAccessHint: 'Bật/tắt quyền theo loại máy cho tài khoản này.',
    uploadMethod: 'Phương thức tải gallery',
    uploadMethodHint: 'Cách máy thuộc tài khoản này upload ảnh/video lên Firebase.',
    uploadMethodServer: 'Truyền thống (qua server)',
    uploadMethodServerDesc: 'App gửi file lên API; server upload tiếp lên Firebase.',
    uploadMethodSigned: 'Trực tiếp (link tạm)',
    uploadMethodSignedDesc: 'Server cấp vé tạm; app PUT thẳng lên Firebase.',
    toastUploadMethodUpdated: 'Đã cập nhật phương thức upload',
    toastUploadMethodFail: 'Không cập nhật được phương thức upload',
    accountTitle: 'Thông tin tài khoản',
    accountHint: 'Cập nhật thông tin tài khoản người dùng',
    roleUser: 'Người dùng',
    roleAdmin: 'Admin',
    roleStaff: 'Nhân viên',
    statusActive: 'Hoạt động',
    statusInactive: 'Tạm khóa',
    changePassword: 'Đổi mật khẩu',
    changePasswordHint: 'Admin đổi mật khẩu cho user này',
    newPassword: 'Mật khẩu mới',
    confirmAsAdmin: 'Xác nhận với mật khẩu admin',
    adminPassword: 'Mật khẩu admin',
    confirm: 'Xác nhận',
    deviceSettings: 'Cài đặt thiết bị',
    toggleDevice: 'Thiết bị',
    toggleDeviceFull: 'Bật quản lý thiết bị',
    toggleDeviceDesc: 'Bật QR / quản lý thiết bị',
    toggleEdit: 'Sửa',
    toggleEditFull: 'Trang Edit',
    toggleEditDesc: 'Nút Edit trên M-Photo Pro',
    toggleMerge: 'Gộp',
    toggleMergeFull: 'Chụp gộp',
    toggleMergeDesc: 'Chụp gộp / In gộp',
    toggleBgRemoval: 'Nền',
    toggleBgRemovalFull: 'Xóa nền',
    toggleBgRemovalDesc: 'Xóa nền AI trên M-Photo Pro + tab Nền custom frame',
    machinesTitle: 'Máy của người dùng',
    machinesCount: '{n} máy',
    deviceOffWarning: 'Thiết bị đang tắt — vẫn xem được máy đã đăng ký.',
    noMachines: 'Chưa có máy nào.',
    tabPrev: 'Tab trước',
    tabNext: 'Tab sau',
    on: 'BẬT',
    off: 'TẮT',
    toastLoadUserFail: 'Không tải được thông tin user',
    toastDeviceUpdated: 'Đã cập nhật quản lý thiết bị',
    toastDeviceUpdateFail: 'Không cập nhật được quản lý thiết bị',
    toastEditOn: 'Đã bật trang Edit',
    toastEditOff: 'Đã tắt trang Edit',
    toastEditFail: 'Không cập nhật được trạng thái Edit',
    toastMergeOn: 'Đã bật chụp gộp',
    toastMergeOff: 'Đã tắt chụp gộp',
    toastMergeFail: 'Không cập nhật được chụp gộp',
    toastBgRemovalOn: 'Đã bật xóa nền',
    toastBgRemovalOff: 'Đã tắt xóa nền',
    toastBgRemovalFail: 'Không cập nhật được xóa nền',
    toastAccessUpdated: 'Đã cập nhật quyền thiết bị',
    toastAccessFail: 'Không cập nhật được quyền thiết bị',
    toastStatusUpdated: 'Đã cập nhật trạng thái user',
    toastStatusFail: 'Không cập nhật được trạng thái user',
    toastUsernameEmailRequired: 'Cần nhập tên đăng nhập và email',
    toastInfoUpdated: 'Đã cập nhật thông tin user',
    toastInfoFail: 'Không cập nhật được thông tin user',
    toastNeedNewPassword: 'Vui lòng nhập mật khẩu mới',
    toastNeedAdminPassword: 'Vui lòng nhập mật khẩu admin',
    toastPasswordUpdated: 'Đã cập nhật mật khẩu user',
    toastPasswordFail: 'Không cập nhật được mật khẩu user',
    toastMachinesFail: 'Không tải được danh sách máy',
    toastMachineDetailFail: 'Không tải được chi tiết máy',
    toastCopiedCode: 'Đã copy mã random',
    toastCopiedLink: 'Đã copy link upload',
    toastCopyFail: 'Không copy được',
    toastAvatarType: 'Chỉ được chọn file ảnh',
    toastAvatarOk: 'Đã cập nhật ảnh đại diện',
    toastAvatarFail: 'Không thể cập nhật ảnh đại diện',
  },
  backgroundAi: {
    title: 'Background AI',
    subtitle: 'Key Fal và PiAPI dùng chung. Mỗi tài khoản tự chọn nhà cung cấp, chất lượng và model.',
    providerTitle: 'Nhà cung cấp',
    using: 'Đang dùng {name}',
    balance: ' · số dư {n}{usd} credit',
    quality: 'Chất lượng',
    qualityLow: 'Thấp',
    qualityMedium: 'Vừa',
    qualityHigh: 'Cao',
    chooseModel: 'Chọn model',
    openList: 'Bấm để mở danh sách',
    noModels: 'Không có model image.',
    falKey: 'Fal key',
    piapiKey: 'PiAPI key',
    noKey: 'Chưa có key {name}',
    revealCountdown: 'Đã xác nhận · còn {s}s không hỏi mật khẩu',
    keyHint: 'Dán key mới để thay. Nút mắt = xem key (cần mật khẩu admin).',
    saveProvider: 'Lưu key',
    falBalance: 'Số dư Fal: {amount}',
    falBalanceLoading: 'Đang kiểm tra số dư Fal...',
    saving: 'Đang lưu...',
    missingKey: 'Nhà cung cấp đang chọn chưa có API key. Dán key ở trên hoặc thêm vào .env (PIAPI_API_KEY / FAL_KEY).',
    presetsTitle: 'Mục nền',
    loading: 'Đang tải...',
    presetCount: '{n} mục',
    reload: 'Tải lại',
    createNew: 'Tạo mục mới',
    noPresets: 'Chưa có mục nền. Tạo mục mới với prompt và ảnh minh họa.',
    accountsTitle: 'Quản lý tài khoản',
    statsTitle: 'Thống kê',
    enabledCount: '{n} đang bật',
    searchUsers: 'Tìm username hoặc email',
    noUsers: 'Không có user phù hợp.',
    usageHistory: 'Lịch sử tạo ảnh',
    themeList: 'Danh sách chủ đề AI',
    themeDialog: 'Chủ đề AI',
    noUserThemes: 'Tài khoản này chưa có chủ đề AI.',
    addTheme: 'Thêm chủ đề AI',
    editTheme: 'Sửa chủ đề AI',
    themeName: 'Tên chủ đề',
    themeDescription: 'Mô tả',
    themeImage: 'Hình chủ đề',
    backgrounds: 'Nền AI',
    backgroundCount: '{n} nền AI',
    addBackground: 'Thêm nền AI',
    editBackground: 'Sửa nền AI',
    backgroundName: 'Tên nền',
    tags: 'Tag',
    tagMale: 'Nam',
    tagFemale: 'Nữ',
    tagGroup: 'Nhóm',
    tagsRequired: 'Chọn ít nhất một tag.',
    confirmDeleteTheme: 'Xóa chủ đề AI này và toàn bộ nền bên trong?',
    confirmDeleteBackground: 'Xóa nền AI này?',
    emptyBackgrounds: 'Chủ đề này chưa có nền AI.',
    back: 'Quay lại',
    accountGenHint: 'API key vẫn dùng chung. Nhà cung cấp, chất lượng và model ở đây chỉ áp dụng cho tài khoản này, trên mlite và mobile upload.',
    accountGenSaved: 'Đã lưu cài đặt tạo ảnh cho tài khoản này',
    accountGenFail: 'Không lưu được cài đặt tạo ảnh',
    multiSlotTitle: 'Bật tạo ảnh AI cho khung nhiều tấm',
    multiSlotHint: 'Khi bật, khung từ 2 ảnh trở lên cũng tạo được ảnh AI. Mỗi ảnh là một lượt gọi API.',
    multiSlotConfirm: 'Chi phí tạo ảnh AI sẽ tăng cao vì mỗi ảnh trong khung được tạo riêng. Bạn có chắc muốn bật không?',
    multiSlotConfirmTitle: 'Bật khung nhiều tấm?',
    multiSlotConfirmYes: 'Bật',
    multiSlotImages: '{n} ảnh',
    quotaTitle: 'Lượt còn lại',
    quotaHint: 'Số bạn lưu sẽ thành số lượt còn lại. Mỗi ảnh tạo thành công trừ 1 lượt. Để trống là không giới hạn.',
    quotaPlaceholder: 'Không giới hạn',
    quotaUsed: 'Đã dùng: {n}',
    quotaRemaining: 'Còn lại: {n}',
    quotaUnlimited: 'Không giới hạn',
    usageTitle: 'Lượt tạo ảnh AI · {name}',
    usageEmpty: 'Tài khoản này chưa có lượt tạo ảnh AI.',
    usageMachine: 'Máy {code}',
    usageMachineNamed: '{name} ({code})',
    usageUnnamed: 'Máy {kind}',
    usageShowing: '{n} lượt tạo',
    usageCostTotal: 'Tổng ${amount}',
    usageCostCalculating: 'Đang tính',
    usageChart2m: '2 tháng',
    usageChart1m: '1 tháng',
    usageChart2w: '2 tuần',
    usageChart1w: '1 tuần',
    usageChart7d: '7 ngày',
    usageChart1d: '1 ngày',
    usageChart2d: '2 ngày',
    usageChartFrom: 'Từ ngày',
    usageChartTo: 'Đến ngày',
    usageChartAccounts: 'Tài khoản',
    usageChartAllAccounts: 'Tất cả tài khoản',
    usageLoadMore: 'Tải thêm',
    usageTheme: 'Chủ đề',
    usageBackground: 'Nền',
    usageSearch: 'Tìm tên máy',
    usageSubjectStats: 'Thống kê sử dụng',
    usageSubjectEmpty: 'Không có lượt tạo trong khoảng này',
    usageSubjectUnknown: 'Không rõ',
    usageSubjectDayHint: 'Chạm một ngày để xem chi tiết',
    usageSubjectWholeRange: 'Cả khoảng',
    usageSubjectTabUse: 'Sử dụng',
    usageSubjectMoney: 'Tiền đã dùng',
    usageSubjectMoneyEmpty: 'Không có chi phí trong khoảng này',
    usageCostRateLimit: 'Fal đang giới hạn lượt lấy giá. Đợi một lát rồi mở lại thống kê.',
    usageFilterAll: 'Tất cả',
    usageNoMatch: 'Không có máy phù hợp.',
    usageLoadFail: 'Không tải được lượt tạo ảnh AI',
    editPreset: 'Chỉnh sửa mục nền AI',
    createPreset: 'Tạo mục nền AI',
    presetName: 'Tên mục',
    prompt: 'Prompt nền',
    promptHelper: 'Chỉ mô tả nền. Ảnh người sẽ được giữ nguyên khi đổi nền.',
    chooseImage: 'Chọn ảnh minh họa',
    cancel: 'Hủy',
    save: 'Lưu',
    create: 'Tạo mục',
    revealTitle: 'Xác nhận — xem API key',
    revealBody: 'Nhập mật khẩu tài khoản admin đang đăng nhập. Sau khi đúng, 5 phút không hỏi lại.',
    adminPassword: 'Mật khẩu admin',
    view: 'Xem',
    toastLoadPresetsFail: 'Không tải được danh sách nền AI',
    toastLoadUsersFail: 'Không tải được danh sách user',
    toastNamePromptRequired: 'Nhập tên mục và prompt nền',
    toastPresetSaved: 'Đã lưu mục nền AI',
    toastPresetCreated: 'Đã tạo mục nền AI',
    toastPresetDeleted: 'Đã xóa mục nền AI',
    toastPresetDeleteFail: 'Không xóa được mục nền AI',
    toastDeleteConfirm: 'Xóa mục "{name}"?',
    toastPresetSaveFail: 'Không lưu được mục nền AI',
    toastUserToggleFail: 'Không cập nhật được quyền user',
    toastPasswordRequired: 'Nhập mật khẩu tài khoản admin.',
    toastPasswordWrong: 'Mật khẩu không đúng.',
    toastQualityFail: 'Không lưu được chất lượng',
    toastModelSelected: 'Đã chọn {model}',
    toastModelFail: 'Không lưu được model',
    toastProviderSwitched: 'Đã lưu API key',
    toastProviderFail: 'Không lưu được nhà cung cấp AI',
    toastCatalogFail: 'Không tải được danh sách model',
  },
};

const ko: AdminMessages = {
  userManagement: {
    title: '사용자 관리',
    createAccount: '생성',
    colUsername: '사용자 이름',
    colEmail: '이메일',
    colRole: '역할',
    colCreatedAt: '생성일',
    colStatus: '상태',
    colActions: '작업',
    blockUser: '사용자 차단',
    activateUser: '활성화',
    dialogTitle: '새 계정 만들기',
    email: '이메일',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    submitCreate: '계정 만들기',
  },
  staffManagement: {
    title: '스태프 관리',
    addStaff: '스태프 추가',
    colUsername: '사용자 이름',
    colEmail: '이메일',
    colRole: '역할',
    colStatus: '상태',
    colCreatedAt: '생성일',
    colActions: '작업',
    edit: '수정',
    promote: '관리자로 승격',
    block: '계정 차단',
    activate: '계정 활성화',
    editDialogTitle: '스태프 수정',
    createDialogTitle: '새 스태프 계정 만들기',
    username: '사용자 이름',
    email: '이메일',
    password: '비밀번호',
    saveChanges: '변경 저장',
    create: '만들기',
  },
  userStaffManagement: {
    title: '직원 계정',
    subtitle: '이 계정의 직원 로그인을 만들고 관리합니다. 직원은 사진과 기기만 볼 수 있습니다.',
    add: '직원 추가',
    empty: '직원 계정이 없습니다',
    emptyHint: '직원이 사진과 기기를 볼 수 있도록 계정을 만들어 주세요.',
    listTitle: '직원 목록',
    statTotal: '전체 직원',
    statActive: '활성',
    statBlocked: '차단됨',
    statTotalShort: '전체',
    statActiveShort: '활성',
    statBlockedShort: '차단',
    colUsername: '사용자 이름',
    colEmail: '이메일',
    colStatus: '상태',
    colCreatedAt: '생성일',
    colActions: '작업',
    edit: '수정',
    block: '차단',
    activate: '활성화',
    createTitle: '직원 계정 만들기',
    editTitle: '직원 계정 수정',
    email: '이메일',
    password: '비밀번호',
    username: '사용자 이름',
    usernameOptional: '사용자 이름 (선택)',
    usernameHint: '비워 두면 이메일에서 생성됩니다',
    newPassword: '새 비밀번호',
    newPasswordHint: '현재 비밀번호를 유지하려면 비워 두세요',
    cancel: '취소',
    create: '만들기',
    save: '저장',
    emailPasswordRequired: '이메일과 비밀번호가 필요합니다',
    loadFail: '직원을 불러오지 못했습니다',
    createOk: '직원 계정이 생성되었습니다',
    createFail: '직원 생성에 실패했습니다',
    updateOk: '직원 계정이 업데이트되었습니다',
    updateFail: '직원 업데이트에 실패했습니다',
    toggleFail: '상태 변경에 실패했습니다',
  },
  customFrames: {
    title: '커스텀 프레임 관리',
    addNew: '새 프레임 추가',
    filterBySize: '프레임 크기로 필터',
    empty: '커스텀 프레임이 없습니다',
    emptyFiltered: '현재 필터에 맞는 프레임이 없습니다',
    photosCount: '사진 {n}장',
    active: '활성',
    inactive: '비활성',
    createdBy: '작성자: {name}',
    created: '생성일: {date}',
    editFrame: '프레임 수정',
    deleteFrame: '프레임 삭제',
    endOfList: '커스텀 프레임 {n}개 모두 표시 (총 {total}개)',
    createDialog: '새 커스텀 프레임 만들기',
    editDialog: '커스텀 프레임 수정',
    frameName: '프레임 이름',
    size: '크기',
    designLink: '디자인 링크',
    designLinkPlaceholder: '디자인 링크 입력',
    designLinkHelper: '디자인 파일 또는 페이지 링크',
    createFrame: '프레임 만들기',
    updateFrame: '프레임 업데이트',
    deleteDialogTitle: '커스텀 프레임 삭제',
    deleteConfirm: '이 커스텀 프레임을 삭제하시겠습니까?',
  },
  albums: {
    title: '앨범 페이지 관리',
    subtitle: '다양한 앨범 링크를 만들고 표지·배경 이미지를 설정하세요.',
    createNew: '새 앨범 페이지 만들기',
    creating: '만드는 중…',
    empty: '앨범 페이지가 아직 없습니다.',
    pathSuffix: '경로 접미사',
    albumLink: '앨범 링크',
    coverImage: '표지 이미지',
    noCover: '표지 이미지가 아직 없습니다',
    enabled: '켜짐',
    disabled: '꺼짐',
    editDialog: '앨범 페이지 수정',
    createDialog: '앨범 페이지 만들기',
    pageName: '앨범 페이지 이름',
    isActive: '활성',
    pageList: '페이지 목록',
    pageOrder: '순서',
    coverPage: '페이지 01 - 앨범 표지',
    coverPageHint: '이름/슬러그, 표지 및 배경 이미지 편집',
    framePage: '페이지 {n} - {name}',
    demoPreview: '앨범 UI 데모',
    pageSettings: '페이지 설정',
    coverPhoto: '표지 사진',
    backgroundPhoto: '배경 사진',
    selectCover: '표지 선택',
    selectBackground: '배경 선택',
    removeCover: '표지 제거',
    uploading: '업로드 중...',
    pickPageHint: '설정을 편집할 페이지를 선택하세요.',
    saveChanges: '변경 저장',
    create: '만들기',
  },
  landing: {
    title: '랜딩 페이지 (백엔드 HTML)',
    subtitle: '클래식 폼 또는 드래그 앤 드롭 캔버스를 선택하세요. 완료 후 저장을 누르세요.',
    classicForm: '클래식 폼',
    canvasMode: '드래그 앤 드롭 캔버스',
    publicLabel: '공개:',
    copy: '복사',
    open: '열기',
    settingsTitle: '콘텐츠 설정',
    reload: '새로고침',
    loading: '로딩 중…',
    saveConfig: '설정 저장',
    saving: '저장 중…',
    unsavedTitle: '저장되지 않은 변경',
    unsavedBody: '나가기 전에 저장하시겠습니까?',
    stay: '머무르기',
    leaveWithoutSave: '저장하지 않고 나가기',
    saveAndLeave: '저장 후 나가기',
  },
  desktops: {
    title: '데스크톱 관리',
    refresh: '새로고침',
    totalMachines: '총 {n}대',
    colMachineCode: '기기 코드',
    colRandomCode: '랜덤 코드',
    colMachineName: '기기 이름',
    colUser: '사용자',
    colStatus: '상태',
    colType: '기기 유형',
    colCreatedAt: '생성일',
    colUpdatedAt: '업데이트',
    colActions: '작업',
    active: '활성',
    inactive: '비활성',
    connected: '연결됨',
    disconnected: '연결 끊김',
    unknownType: '미확인',
    updateRandomCode: '랜덤 코드 업데이트',
    previous: '이전',
    next: '다음',
    pageOf: '{page} / {totalPages} 페이지',
    dialogTitle: '랜덤 코드 업데이트',
    dialogConfirm: '이 기기의 새 랜덤 코드를 생성할까요?',
    currentRandomCode: '현재 랜덤 코드',
    update: '업데이트',
  },
  softwareUpdate: {
    title: '소프트웨어 업데이트',
    refresh: '새로고침',
    dropActive: '여기에 파일을 놓으세요',
    dropIdleApk: '.apk 파일을 드래그하거나 클릭하여 선택',
    dropIdleExe: '.exe 파일을 드래그하거나 클릭하여 선택',
    currentChannel: '현재 채널: {channel}',
    hintApk: '.apk만 허용, 최대 1GB',
    hintExe: '.exe만 허용, 최대 1GB',
    uploading: '파일 업로드 중...',
    currentFile: '현재 파일',
    fileName: '파일 이름',
    fileSize: '크기',
    uploadDate: '업로드 날짜',
    uploadedBy: '업로드한 사람',
    download: '다운로드',
    empty: '업로드된 업데이트 파일이 없습니다',
    updateInfo: '업데이트 정보',
    saveInfo: '정보 저장',
    saving: '저장 중...',
    deleteTitle: '삭제 확인',
    deleteConfirm: '이 업데이트 파일을 삭제하시겠습니까?',
    deleting: '삭제 중...',
  },
  email: {
    tabCompose: '이메일 작성',
    tabSent: '보낸 이메일',
    title: '이메일',
    subject: '이메일 제목',
    subjectPlaceholder: '제목을 입력하세요...',
    bodyLabel: '이메일 본문 (HTML)',
    bodyPlaceholder: '본문을 입력하세요...',
    recipientList: '이메일 목록',
    recipientPlaceholder: '이메일을 입력하고 Space를 누르세요…',
    clearAll: '모두 지우기',
    clearAllConfirm: '모든 이메일을 지울까요?',
    sendingProgress: '전송 중: {sent}/{total}',
    cancelSendConfirm: '정말 취소하시겠습니까?',
    send: '이메일 보내기',
    sending: '보내는 중...',
    search: '검색',
    searchPlaceholder: '수신자/제목/발신자로 검색...',
    deleteSelected: '삭제',
    deleteConfirm: '보낸 이메일 {n}개를 삭제할까요?',
    colSubject: '제목',
    colPreview: '미리보기',
    colRecipients: '수신자',
    colStats: '통계',
    colTime: '시간',
    empty: '이메일이 아직 없습니다',
    statsChip: '{sent} SENT / {failed} FAILED',
    recipientsCount: '수신자 {n}명',
    pageOf: '{page} / {totalPages} 페이지',
    prev: '이전',
    next: '다음',
    detailTitle: '이메일 상세',
    noData: '데이터 없음',
  },
  userDetail: {
    userNotFound: '사용자를 찾을 수 없습니다',
    tabs: {
      profile: '프로필',
      pro: 'Pro',
      proFull: 'M-Photo Pro',
      lite: 'Lite',
      liteFull: 'M-Photo Lite',
      mono: 'Mono',
      monoFull: 'M-Photo Mono',
      frame: '프레임',
      frameFull: '커스텀 프레임',
      media: '미디어',
      device: '기기',
      deviceFull: '기기 관리',
      sepay: 'SePay',
      staff: '직원',
    },
    deviceAccess: '기기 권한',
    deviceAccessHint: '이 계정의 제품별 권한을 켜거나 끕니다.',
    uploadMethod: '갤러리 업로드 방식',
    uploadMethodHint: '이 계정 기기들이 사진/영상을 올리는 방식입니다.',
    uploadMethodServer: '기존 방식 (서버 경유)',
    uploadMethodServerDesc: '앱이 API로 파일을 보내면 서버가 Firebase에 업로드합니다.',
    uploadMethodSigned: '직접 업로드 (임시 링크)',
    uploadMethodSignedDesc: '서버가 임시 링크를 발급하고 앱이 Firebase에 바로 올립니다.',
    toastUploadMethodUpdated: '업로드 방식이 업데이트되었습니다',
    toastUploadMethodFail: '업로드 방식을 업데이트하지 못했습니다',
    accountTitle: '계정 정보',
    accountHint: '이 사용자 계정 정보를 업데이트합니다',
    roleUser: '사용자',
    roleAdmin: '관리자',
    roleStaff: '스태프',
    statusActive: '활성',
    statusInactive: '비활성',
    changePassword: '비밀번호 변경',
    changePasswordHint: '관리자가 이 사용자의 비밀번호를 변경합니다',
    newPassword: '새 비밀번호',
    confirmAsAdmin: '관리자 확인',
    adminPassword: '관리자 비밀번호',
    confirm: '확인',
    deviceSettings: '기기 설정',
    toggleDevice: '기기',
    toggleDeviceFull: '기기 관리 사용',
    toggleDeviceDesc: 'QR / 기기 관리를 켭니다',
    toggleEdit: '편집',
    toggleEditFull: '편집 페이지',
    toggleEditDesc: 'M-Photo Pro의 Edit 버튼',
    toggleMerge: '합치기',
    toggleMergeFull: '연속 촬영',
    toggleMergeDesc: '합쳐 찍기 / 합쳐 인쇄',
    toggleBgRemoval: '배경',
    toggleBgRemovalFull: '배경 제거',
    toggleBgRemovalDesc: 'M-Photo Pro AI 배경 제거 + 커스텀 프레임 배경 탭',
    machinesTitle: '사용자 기기',
    machinesCount: '기기 {n}대',
    deviceOffWarning: '기기가 꺼져 있습니다 — 등록된 기기는 계속 볼 수 있습니다.',
    noMachines: '기기가 아직 없습니다.',
    tabPrev: '이전 탭',
    tabNext: '다음 탭',
    on: 'ON',
    off: 'OFF',
    toastLoadUserFail: '사용자 정보를 불러오지 못했습니다',
    toastDeviceUpdated: '기기 관리 상태가 업데이트되었습니다',
    toastDeviceUpdateFail: '기기 관리 상태를 업데이트하지 못했습니다',
    toastEditOn: '편집 페이지가 켜졌습니다',
    toastEditOff: '편집 페이지가 꺼졌습니다',
    toastEditFail: '편집 페이지 상태를 업데이트하지 못했습니다',
    toastMergeOn: '연속 촬영이 켜졌습니다',
    toastMergeOff: '연속 촬영이 꺼졌습니다',
    toastMergeFail: '연속 촬영 상태를 업데이트하지 못했습니다',
    toastBgRemovalOn: '배경 제거가 켜졌습니다',
    toastBgRemovalOff: '배경 제거가 꺼졌습니다',
    toastBgRemovalFail: '배경 제거 상태를 업데이트하지 못했습니다',
    toastAccessUpdated: '기기 권한이 업데이트되었습니다',
    toastAccessFail: '기기 권한을 업데이트하지 못했습니다',
    toastStatusUpdated: '사용자 상태가 업데이트되었습니다',
    toastStatusFail: '사용자 상태를 업데이트하지 못했습니다',
    toastUsernameEmailRequired: '사용자 이름과 이메일이 필요합니다',
    toastInfoUpdated: '사용자 정보가 업데이트되었습니다',
    toastInfoFail: '사용자 정보를 업데이트하지 못했습니다',
    toastNeedNewPassword: '새 비밀번호를 입력하세요',
    toastNeedAdminPassword: '관리자 비밀번호를 입력하세요',
    toastPasswordUpdated: '사용자 비밀번호가 업데이트되었습니다',
    toastPasswordFail: '사용자 비밀번호를 업데이트하지 못했습니다',
    toastMachinesFail: '기기 목록을 불러오지 못했습니다',
    toastMachineDetailFail: '기기 상세를 불러오지 못했습니다',
    toastCopiedCode: '랜덤 코드를 복사했습니다',
    toastCopiedLink: '업로드 링크를 복사했습니다',
    toastCopyFail: '텍스트를 복사할 수 없습니다',
    toastAvatarType: '이미지 파일만 선택할 수 있습니다',
    toastAvatarOk: '프로필 사진이 업데이트되었습니다',
    toastAvatarFail: '프로필 사진을 업데이트하지 못했습니다',
  },
  backgroundAi: {
    title: 'Background AI',
    subtitle: 'Fal과 PiAPI 키는 공통입니다. 제공자, 품질, 모델은 각 계정에서 선택합니다.',
    providerTitle: '제공자',
    using: '{name} 사용 중',
    balance: ' · 잔액 {n}{usd} 크레딧',
    quality: '품질',
    qualityLow: '낮음',
    qualityMedium: '보통',
    qualityHigh: '높음',
    chooseModel: '모델 선택',
    openList: '눌러서 목록 열기',
    noModels: '이미지 모델이 없습니다.',
    falKey: 'Fal 키',
    piapiKey: 'PiAPI 키',
    noKey: '{name} 키가 없습니다',
    revealCountdown: '확인됨 · 비밀번호를 다시 묻기까지 {s}초',
    keyHint: '새 키를 붙여넣어 교체합니다. 눈 아이콘은 키를 표시합니다(관리자 비밀번호 필요).',
    saveProvider: '키 저장',
    falBalance: 'Fal 잔액: {amount}',
    falBalanceLoading: 'Fal 잔액 확인 중...',
    saving: '저장 중...',
    missingKey: '선택한 제공자에 API 키가 없습니다. 위에 붙여넣거나 .env에 PIAPI_API_KEY / FAL_KEY를 추가하세요.',
    presetsTitle: '배경',
    loading: '불러오는 중...',
    presetCount: '{n}개',
    reload: '새로고침',
    createNew: '새 배경',
    noPresets: '배경이 없습니다. 프롬프트와 미리보기 이미지로 만드세요.',
    accountsTitle: '계정 관리',
    statsTitle: '통계',
    enabledCount: '{n}개 사용 중',
    searchUsers: '사용자 이름 또는 이메일 검색',
    noUsers: '해당하는 사용자가 없습니다.',
    usageHistory: '생성 기록',
    themeList: 'AI 주제 목록',
    themeDialog: 'AI 주제',
    noUserThemes: '이 계정에는 AI 주제가 없습니다.',
    addTheme: 'AI 주제 추가',
    editTheme: 'AI 주제 수정',
    themeName: '주제 이름',
    themeDescription: '설명',
    themeImage: '주제 이미지',
    backgrounds: 'AI 배경',
    backgroundCount: 'AI 배경 {n}개',
    addBackground: 'AI 배경 추가',
    editBackground: 'AI 배경 수정',
    backgroundName: '배경 이름',
    tags: '태그',
    tagMale: '남성',
    tagFemale: '여성',
    tagGroup: '그룹',
    tagsRequired: '태그를 하나 이상 선택하세요.',
    confirmDeleteTheme: '이 AI 주제와 안의 모든 배경을 삭제할까요?',
    confirmDeleteBackground: '이 AI 배경을 삭제할까요?',
    emptyBackgrounds: '이 주제에는 아직 AI 배경이 없습니다.',
    back: '뒤로',
    accountGenHint: 'API 키는 공통입니다. 여기의 제공자, 품질, 모델은 이 계정의 mlite와 모바일 업로드에만 적용됩니다.',
    accountGenSaved: '이 계정의 이미지 설정을 저장했습니다',
    accountGenFail: '이미지 설정을 저장하지 못했습니다',
    multiSlotTitle: '여러 장 프레임 AI 생성',
    multiSlotHint: '켜면 사진 2장 이상인 프레임도 AI 이미지를 만들 수 있습니다. 사진마다 API를 호출합니다.',
    multiSlotConfirm: '프레임의 사진마다 따로 생성되므로 AI 비용이 높아집니다. 켤까요?',
    multiSlotConfirmTitle: '여러 장 AI를 켤까요?',
    multiSlotConfirmYes: '켜기',
    multiSlotImages: '{n}장',
    quotaTitle: '남은 AI 횟수',
    quotaHint: '저장한 숫자가 남은 횟수가 됩니다. 생성된 사진 1장당 1회입니다. 비우면 제한이 없습니다.',
    quotaPlaceholder: '제한 없음',
    quotaUsed: '사용: {n}',
    quotaRemaining: '남음: {n}',
    quotaUnlimited: '제한 없음',
    usageTitle: 'AI 생성 · {name}',
    usageEmpty: '이 계정에는 아직 AI 생성이 없습니다.',
    usageMachine: '기기 {code}',
    usageMachineNamed: '{name} ({code})',
    usageUnnamed: '{kind} 기기',
    usageShowing: '{n}회 생성',
    usageCostTotal: '합계 ${amount}',
    usageCostCalculating: '계산 중',
    usageChart2m: '2개월',
    usageChart1m: '1개월',
    usageChart2w: '2주',
    usageChart1w: '1주',
    usageChart7d: '7일',
    usageChart1d: '1일',
    usageChart2d: '2일',
    usageChartFrom: '시작',
    usageChartTo: '종료',
    usageChartAccounts: '계정',
    usageChartAllAccounts: '전체 계정',
    usageLoadMore: '더 보기',
    usageTheme: '주제',
    usageBackground: '배경',
    usageSearch: '기기 이름 검색',
    usageSubjectStats: '사용 통계',
    usageSubjectEmpty: '이 기간에 생성 기록이 없습니다',
    usageSubjectUnknown: '알 수 없음',
    usageSubjectDayHint: '날짜를 누르면 그날만 보여요',
    usageSubjectWholeRange: '전체 기간',
    usageSubjectTabUse: '사용',
    usageSubjectMoney: '사용 금액',
    usageSubjectMoneyEmpty: '이 기간에 비용이 없습니다',
    usageCostRateLimit: 'Fal이 가격 조회를 제한하고 있어요. 잠시 후 통계를 다시 여세요.',
    usageFilterAll: '전체',
    usageNoMatch: '해당하는 기기가 없습니다.',
    usageLoadFail: 'AI 생성 목록을 불러오지 못했습니다',
    editPreset: 'AI 배경 편집',
    createPreset: 'AI 배경 만들기',
    presetName: '이름',
    prompt: '배경 프롬프트',
    promptHelper: '배경만 설명하세요. 사진 속 인물은 그대로 유지됩니다.',
    chooseImage: '미리보기 이미지 선택',
    cancel: '취소',
    save: '저장',
    create: '만들기',
    revealTitle: '확인 — API 키 보기',
    revealBody: '로그인한 관리자 계정 비밀번호를 입력하세요. 맞으면 5분 동안 다시 묻지 않습니다.',
    adminPassword: '관리자 비밀번호',
    view: '보기',
    toastLoadPresetsFail: 'AI 배경 목록을 불러오지 못했습니다',
    toastLoadUsersFail: '사용자 목록을 불러오지 못했습니다',
    toastNamePromptRequired: '이름과 배경 프롬프트를 입력하세요',
    toastPresetSaved: 'AI 배경을 저장했습니다',
    toastPresetCreated: 'AI 배경을 만들었습니다',
    toastPresetSaveFail: 'AI 배경을 저장하지 못했습니다',
    toastPresetDeleted: 'AI 배경을 삭제했습니다',
    toastPresetDeleteFail: 'AI 배경을 삭제하지 못했습니다',
    toastDeleteConfirm: '"{name}"을(를) 삭제할까요?',
    toastUserToggleFail: '사용자 권한을 업데이트하지 못했습니다',
    toastPasswordRequired: '관리자 계정 비밀번호를 입력하세요.',
    toastPasswordWrong: '비밀번호가 올바르지 않습니다.',
    toastQualityFail: '품질을 저장하지 못했습니다',
    toastModelSelected: '{model}을(를) 선택했습니다',
    toastModelFail: '모델을 저장하지 못했습니다',
    toastProviderSwitched: 'API 키를 저장했습니다',
    toastProviderFail: 'AI 제공자를 저장하지 못했습니다',
    toastCatalogFail: '모델 목록을 불러오지 못했습니다',
  },
};

export const adminMessages: Record<AppLang, AdminMessages> = { en, vi, ko, zh: zhAdmin };
